import React from "react";
import {
    SCHEDULES_REPORT_REVENUE_SUB_MODE_LABELS,
    SchedulesReportRevenueSubMode,
} from "@common/types/reports/schedules-report";
import { SchedulesReportEnumSelect } from "./SchedulesReportEnumSelect";

interface Props {
    value: SchedulesReportRevenueSubMode;
    onChange: (revenueSubMode: SchedulesReportRevenueSubMode) => void;
}

export const RevenueSubModeSelect: React.FC<Props> = ({ value, onChange }) => (
    <SchedulesReportEnumSelect
        value={value}
        options={Object.values(SchedulesReportRevenueSubMode)}
        allValue={SchedulesReportRevenueSubMode.all}
        labels={SCHEDULES_REPORT_REVENUE_SUB_MODE_LABELS}
        prefix="Revenue"
        onChange={onChange}
    />
);
